import { LegacySequelizeUser } from '@harvestiq/iiq-common'
import { LegacyIIQApi } from '../legacy-iiq-api'

// TODO: All these methods should have an equivalent on insureiq-api-client and these below should be removed

export const getUserPolicies =
  ({ legacyIIQApi: api }: { legacyIIQApi: LegacyIIQApi }) =>
  (userId = 'me', params: Record<string, any> = {}) =>
    api.get(`/users/${userId}/policies`, params).then(resp => resp?.data)

export const updateUserProfileByUserId =
  ({ legacyIIQApi: api }: { legacyIIQApi: LegacyIIQApi }) =>
  (userId: string, body: Record<string, any>) =>
    api.patch(`/users/${userId}/profile`, body)

export const updateUserPersonalInformations =
  ({ legacyIIQApi: api }: { legacyIIQApi: LegacyIIQApi }) =>
  (userId: string, params: Record<string, any>) =>
    api.patch(`/profile/personal/${userId}`, params)

export const updateUserBusinessInformation =
  ({ legacyIIQApi: api }: { legacyIIQApi: LegacyIIQApi }) =>
  (userId: string, params: Record<string, any>) =>
    api.patch(`/profile/business/${userId}`, params)

export const deleteUserById =
  ({ legacyIIQApi: api }: { legacyIIQApi: LegacyIIQApi }) =>
  (userId: string) =>
    api
      .delete(`/users/${userId}`)
      .then(({ data, errors }) => ({ data, errors }))

export const removeUserRole =
  ({ legacyIIQApi: api }: { legacyIIQApi: LegacyIIQApi }) =>
  (userId: string, roleId: string) =>
    api
      .delete(`/users/${userId}/roles/${roleId}`)
      .then(({ data, errors }) => ({ data, errors }))

export const addUserRole =
  ({ legacyIIQApi: api }: { legacyIIQApi: LegacyIIQApi }) =>
  (userId: string, roleId: string) =>
    api
      .post(`/users/${userId}/roles`, { roleId })
      .then(({ data, errors }) => ({ data, errors }))

export const assignAgent =
  ({ legacyIIQApi: api }: { legacyIIQApi: LegacyIIQApi }) =>
  async (
    {
      userId,
      agentId,
      previousAgentId,
    }: {
      userId: string
      agentId: string
      previousAgentId?: string
    },
    overridable = true,
  ) => {
    // referral links should not override existing agent assignments
    if (!overridable && previousAgentId) {
      return
    }

    await api.patch(`/users/${userId}/agents`, { agentId })
  }
